import LookupProductsRequestModelBase from '../_generated/modelBases/lookup-products-request-model-base';

export default class LookupProductsRequestModel extends LookupProductsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
